<!--
 * @Description: 
 * @Date: 2021-02-06 14:51:38
-->
<template>
  <div class="living-title" v-if="livingStore.livingConf.isShowPerson">
    <h5>{{ livingStore.detail.courseName }}</h5>
    <p v-if="livingStore.livingConf.isShowPerson && !isEnd">
      <img :src="require('@/assets/data.gif')" alt style="width:.35rem;" />
      {{ users }} 人正在观看
    </p>
  </div>
</template>

<script>
import { useTWEEN } from '@/utils/tools';
export default {
  name: 'LivingTitle',
  inject: ['livingStore'],
  data() {
    return {};
  },
  components: {},
  watch: {},
  computed: {
    users() {
      const livingConf = this.livingStore.livingConf;
      let {
        basePersonNum,
        personMulti,
        isPersonMulti,
        showPersonType,
        isBasePerson
      } = livingConf;
      // 使用实际数据还是总人数
      let users =
        showPersonType === 1
          ? this.livingStore.totalUsers
          : this.livingStore.realUsers;
      return (
        // 基数 + 用户数 * 倍数
        ((isBasePerson && basePersonNum) || 0) +
        users * ((isPersonMulti && personMulti) || 1)
      );
    },
    isEnd() {
      return this.livingStore.livingStatus === 3;
    }
  }
};
</script>

<style scoped lang="scss">
.living-title {
  padding: 0.2rem 0.37rem;
  h5 {
    margin-bottom: 0.24rem;
    font-size: 0.37rem;
  }
  p {
    color: #666666;
    display: flex;
    align-items: center;
    img {
      margin-right: 0.1rem;
    }
  }
}
</style>
